import request from '@/utils/request'


const ssoApi = {

}

ssoApi.checkHeartbeat = () => {
  return request({
    url: '/sso/checkHeartbeat',
    method: 'post'
  })
}

ssoApi.ssoLogin = code => {
  return request({
    url: '/sso/login/' + code,
    method: 'post'
  })
}

ssoApi.getAccessToken = ssoParam => {
  return request({
    url: '',
    method: 'post'
  })
}

ssoApi.getLogin = data => {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}


export default ssoApi
